<template>
  <div class="dettaglio-trattativa" v-loading="loading">

    <div class="header-tab">
      <div class="my-label col-24 no-padding" v-if="!ifNuovaTrattativa">
        {{ $t('dettaglioTrattativa.trattativaNum').toUpperCase() + ' ' + trattativa.numTrattativa }}
      </div>
      <div class="my-label col-24 no-padding" v-else>
        {{ $t('dettaglioTrattativa.nuovaTrattativa').toUpperCase() }}
      </div>
      <div class="sotto-label col-24 no-padding" v-if="!ifNuovaTrattativa">
        {{ '(' + $t('dettaglioTrattativa.del') + ' ' }}{{ trattativa.datTrattativa }}{{ ')' }}
      </div>
    </div>

    <div class="testata-trattativa">
      <div class="row row-custom">

        <div class="offset-lg-0 col-lg-11 offset-md-2 col-md-17 offset-sm-1 col-sm-20 col-24">

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.validita') }}
            </div>
            <el-date-picker class="col-16 no-padding custom-date-picker-range" :disabled="(ifDisabled || ifAutomatica)"
              v-model="testata.validita"
              type="daterange"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              :picker-options="{
                firstDayOfWeek: 1
              }"
            >
            </el-date-picker>
          </div>

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.stabilimento') }}
            </div>
            <el-select v-model="testata.stabilimento" class="col-16 no-padding custom-select-el" value-key="key" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in stabilimenti"
                :key="item.key"
                :label="item.descStab"
                :value="item">
              </el-option>
            </el-select>
          </div>

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.resa') }}
            </div>
            <el-select v-model="testata.resa" class="col-16 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in rese"
                :key="item.codResa"
                :label="item.desResa"
                :value="item.codResa">
              </el-option>
            </el-select>
          </div>

          <div class="elemento row row-custom" v-if="(countryTrattativa === '1')">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.tipoMateriale') }}
            </div>
            <el-select v-model="testata.tipoMateriale" class="col-16 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in tipiMateriale"
                :key="item.codTipoMat"
                :label="item.desTipoMat"
                :value="item.codTipoMat">
              </el-option>
            </el-select>
          </div>

        </div>

        <div class="offset-lg-0 col-lg-11 offset-md-2 col-md-17 offset-sm-1 col-sm-20 col-24">

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.datCons') }}
            </div>
            <el-date-picker class="col-16 no-padding custom-date-picker-range" :disabled="(ifDisabled || ifAutomatica)"
                            v-model="testata.datCons"
                            type="daterange"
                            format="dd/MM/yyyy"
                            value-format="dd/MM/yyyy"
                            :picker-options="{
                              firstDayOfWeek: 1
                            }"
            >
            </el-date-picker>
          </div>

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.spedizione') }}
            </div>
            <el-select v-model="testata.spedizione" class="col-16 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in spedizioni"
                :key="item.codSpediz"
                :label="item.desSpediz"
                :value="item.codSpediz">
              </el-option>
            </el-select>
          </div>

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.percTolleranza') }}
            </div>
            <el-select v-model="testata.percTolleranza" class="col-16 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in tolleranze"
                :key="item.tolleranza"
                :label="(item.tolleranza + ' ' + item.unMis)"
                :value="item.tolleranza">
              </el-option>
            </el-select>
          </div>

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.subFornEProv') }}
            </div>

            <div class="col-2 no-padding">
              <el-tooltip class="item" effect="dark" :content="($t('dettaglioTrattativa.subFornProv'))" placement="top">
                <icon class="pointer" name="riv-subForProv" scale="1" @click.native="(subFornLocProvVisible = true)"></icon>
              </el-tooltip>
            </div>

            <div class="el-label col-6">
              {{ $t('dettaglioTrattativa.divisa') }}
            </div>

            <el-select v-model="testata.divisa" class="col-8 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in divise"
                :key="item.divisa"
                :label="item.divisa + ' - ' + item.desDivisa"
                :value="item.divisa">
              </el-option>
            </el-select>
          </div>

        </div>

      </div>

      <div class="row row-custom">

        <div class="offset-lg-0 col-lg-11 offset-md-2 col-md-17 offset-sm-1 col-sm-20 col-24">
          <div class="elemento row row-custom" style="margin-bottom: 10px">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.notaUfficio') }}
            </div>
            <el-input
              class="col-16 no-padding custom-input"
              type="textarea" disabled
              :autosize="{ minRows: 2, maxRows: 2 }"
              v-model="testata.notaUfficio">
            </el-input>
          </div>
        </div>

        <div class="offset-lg-0 col-lg-11 offset-md-2 col-md-17 offset-sm-1 col-sm-20 col-24">
          <div class="elemento row row-custom" style="margin-bottom: 10px">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.notaFornitore') }}
            </div>
            <el-input
              class="col-16 no-padding custom-input" :disabled="(ifDisabled || ifAutomatica)"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2 }"
              v-model="testata.notaFornitore">
            </el-input>
          </div>
        </div>

      </div>

      <!--
      <div class="row row-custom">

        <div class="col-lg-11">

          <div class="elemento row row-custom" style="margin-bottom: 0; height: 100%">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.notaUfficio') }}
            </div>
            <el-input
              class="col-16 no-padding custom-input"
              type="textarea" disabled
              :autosize="{ minRows: 3, maxRows: 3 }"
              v-model="testata.notaUfficio">
            </el-input>
          </div>

        </div>

        <div class="col-lg-11">

          <div class="elemento row row-custom">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.subFornEProv') }}
            </div>

            <div class="col-2 no-padding">
              <el-tooltip class="item" effect="dark" :content="($t('dettaglioTrattativa.subFornProv'))" placement="top">
                <icon class="pointer" name="riv-subForProv" scale="1" @click.native="(subFornLocProvVisible = true)"></icon>
              </el-tooltip>
            </div>

            <div class="el-label col-6">
              {{ $t('dettaglioTrattativa.divisa') }}
            </div>

            <el-select v-model="testata.divisa" class="col-8 no-padding custom-select-el" :disabled="(ifDisabled || ifAutomatica)">
              <el-option
                v-for="item in divise"
                :key="item.divisa"
                :label="item.divisa + ' - ' + item.desDivisa"
                :value="item.divisa">
              </el-option>
            </el-select>
          </div>

          <div class="elemento row row-custom" style="margin-bottom: 0">
            <div class="el-label col-8">
              {{ $t('dettaglioTrattativa.notaFornitore') }}
            </div>
            <el-input
              class="col-16 no-padding custom-input" :disabled="(ifDisabled || ifAutomatica)"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2 }"
              v-model="testata.notaFornitore">
            </el-input>
          </div>

        </div>

      </div>
      -->
    </div>

    <div class="prodotti">
      <el-table :data="elencoProdotti" class="col-24 no-padding custom-table">

        <el-table-column
          prop="numConf" header-align="center" align="center"
          :label="($t('dettaglioTrattativa.numConf'))"
          width="120">
        </el-table-column>

        <el-table-column
          :label="($t('dettaglioTrattativa.prodotto'))"
          min-width="300">
          <template slot-scope="scope">
            <div class="prodotto">
              {{ scope.row.codProd + ' ' + scope.row.codCECA + ' ' + scope.row.codEurofer + ' ' + scope.row.desProd }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center" align="center"
          :label="($t('dettaglioTrattativa.qta'))"
          min-width="115">
          <template slot-scope="scope">
            <el-input class="custom-input" v-model="elencoProdotti[scope.$index].qtaOfferta" @keyup.native="formatQta(scope.$index)" :disabled="ifDisabled"></el-input>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center" align="center"
          min-width="115">
          <template slot="header">
            <span v-html="($t('dettaglioTrattativa.prezzo') + ((testata.divisa !== '') ? testata.divisa : '-') + $t('dettaglioTrattativa.prezzo2'))"></span>
          </template>
          <template slot-scope="scope">
            <el-input class="custom-input" v-model="elencoProdotti[scope.$index].prezzoForn" @keyup.native="formatPrz(scope.$index, 'prezzoForn')" :disabled="ifDisabled"></el-input>
          </template>
        </el-table-column>

        <el-table-column
          prop="prezzoUff" header-align="center" align="center"
          min-width="170">
          <template slot="header">
            <span v-html="($t('dettaglioTrattativa.prezzoRichiesto') + ((testata.divisa !== '') ? testata.divisa : '-') + $t('dettaglioTrattativa.prezzoRichiesto2'))"></span>
          </template>
        </el-table-column>

        <el-table-column
          prop="prezzoMesePrec" header-align="center" align="center"
          min-width="170">
          <template slot="header">
            <span v-html="($t('dettaglioTrattativa.prezzoMesePrec') + ((testata.divisa !== '') ? testata.divisa : '-') + $t('dettaglioTrattativa.prezzoMesePrec2'))"></span>
          </template>
        </el-table-column>

        <el-table-column
          prop="differenza" header-align="center" align="center"
          min-width="170">
          <template slot="header">
            <span v-html="($t('dettaglioTrattativa.differenza') + ' (' + ((testata.divisa !== '') ? testata.divisa : '-') +')')"></span>
          </template>
        </el-table-column>

        <el-table-column
          width="40">
          <template slot-scope="scope">
            <div class="elimina pointer" @click="eliminaProdotto(scope.$index)" v-if="(scope.row.ifElimina === true)">
              <icon name="riv-delete2" scale="1"></icon>
            </div>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <div class="add col-24">
      <!--
      <el-tooltip class="item" effect="dark" :content="($t('dettaglioTrattativa.aggiungiProdotto'))" placement="top">
        <el-button class="custom-button" @click="goToAddProdotti">
          <icon class="pointer" name="riv-plusRounded" scale="1.3"></icon>
        </el-button>
      </el-tooltip>
      -->
      <el-button class="custom-button" @click="goToAddProdotti">
        {{ $t('dettaglioTrattativa.aggiungi').toUpperCase() }}
      </el-button>
    </div>

    <div class="bottoni">
      <el-button class="custom-button" type="primary" @click="salva" :disabled="ifDisabled">{{ $t('dettaglioTrattativa.salva').toUpperCase() }}</el-button>
    </div>

    <el-dialog
      :title="($t('dettaglioTrattativa.subFornLocProvTitle').toUpperCase())"
      :visible.sync="subFornLocProvVisible" :append-to-body="true"
      custom-class="custom-dialog dialog-subforn-locprov col-xl-12 col-lg-16 col-md-20 col-24"
    >

      <div class="contenitore">
        <div class="box-sx">
          <el-checkbox-group v-model="subFornSelected" @change="changeSubFornSelected" :disabled="(ifDisabled || ifAutomatica)">
            <el-checkbox class="custom-checkbox" v-for="item in subFornitori" :key="item.codSubfor" :label="item.codSubfor">{{ item.codSubfor + ' - ' + item.desSubfor }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="box-dx">
          <el-checkbox-group v-model="locProvSavedSelected" :disabled="(ifDisabled || ifAutomatica)">
            <el-checkbox class="custom-checkbox" v-for="item in locProvSaved" :key="item.codLoca" :label="item.codLoca">{{ item.codLoca + ' - ' + item.desLoca }}</el-checkbox>
          </el-checkbox-group>
          <el-checkbox-group v-model="locProvSelected" :disabled="(ifDisabled || ifAutomatica)">
            <el-checkbox class="custom-checkbox" v-for="item in locProvComputed" :key="item.codLoca" :label="item.codLoca">{{ item.codLoca + ' - ' + item.desLoca }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="custom-button" type="primary" @click="changeSubFornProv" :disabled="(ifDisabled || ifAutomatica)">{{ $t('dettaglioTrattativa.salva').toUpperCase() }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="($t('dettaglioTrattativa.addProdottiTitle').toUpperCase())"
      :visible.sync="addProdottiVisible" :append-to-body="true"
      custom-class="custom-dialog dialog-prodotti col-xl-12 col-lg-16 col-md-20 col-24"
    >

      <div class="col-24 no-padding filtro">
        <el-input class="custom-input input-filtro" v-model="filtroProdotti" clearable :maxlength="30" @keyup.enter.native="getProdotti"></el-input>
        <div class="ricerca pointer" @click="getProdotti">
          <icon name="riv-search" scale="1"></icon>
        </div>
      </div>

      <div class="contenitore" v-loading="loadingProdotti">
        <el-table :data="prodotti" class="col-24 no-padding custom-table" :show-header="false"  @selection-change="handleSelectionChange" ref="multipleTable">

          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
          <el-table-column
            prop="codProd"
            :label="($t('dettaglioTrattativa.numConf'))"
            width="70">
          </el-table-column>

          <el-table-column
            prop="codCECA"
            :label="($t('dettaglioTrattativa.prodotto'))"
            width="70">
          </el-table-column>

          <el-table-column
            prop="codEurofer"
            :label="($t('dettaglioTrattativa.qta'))"
            width="100">
          </el-table-column>

          <el-table-column
            prop="desProd"
            min-width="200">
          </el-table-column>

        </el-table>

        <!--
        <el-checkbox-group v-model="addProdottiSelected">
          <el-checkbox class="custom-checkbox" v-for="item in prodotti" :key="item.codProd" :label="item.codProd">
            {{ item.codProd + ' ' + item.codCECA + ' ' + item.codEurofer + ' ' + item.desProd }}
          </el-checkbox>
        </el-checkbox-group>
        -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="custom-button" type="primary" @click="addProdotti" :disabled="(ifDisabled || ifAutomatica)">{{ $t('dettaglioTrattativa.aggiungi').toUpperCase() }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {bus} from '../../Bus'

  export default {
    name: 'DettaglioTrattativa',
    i18n: {
      messages: {
        it_IT: {
          dettaglioTrattativa: {
            trattativaNum: 'Trattativa N.',
            del: 'del',
            nuovaTrattativa: 'Nuova Trattativa',
            validita: 'Validità',
            numConf: 'Conferma',
            datCons: 'Consegna/Spedizione',
            spedizione: 'Spedizione',
            stabilimento: 'Stabilimento',
            resa: 'Resa',
            percTolleranza: 'Tolleranza',
            notaUfficio: 'Nota Ufficio',
            subFornEProv: 'Provenienza',
            notaFornitore: 'Nota Fornitore',
            prodotto: 'Prodotto',
            qta: 'Qtà (Ton)',
            prezzo: 'Prezzo<br>(',
            prezzo2: '/Ton)',
            prezzoRichiesto: 'Prezzo<br>Richiesto (',
            prezzoRichiesto2: '/Ton)',
            prezzoMesePrec: 'Prezzo Mese<br>Precedente (',
            prezzoMesePrec2: '/Ton)',
            differenza: 'Differenza',
            subFornLocProvTitle: 'Seleziona subfornitori e provenienza',
            addProdottiTitle: 'Seleziona Prodotto',
            aggiungi: 'Aggiungi',
            salva: 'Salva',
            divisa: 'Valuta',
            aggiungiProdotto: 'Aggiungi Prodotto',
            subFornProv: 'Subfornitori e Provenienza',
            tipoMateriale: 'Tipo Materiale'
          }
        },
        fr_FR: {
          dettaglioTrattativa: {
          }
        },
        es_ES: {
          dettaglioTrattativa: {
          }
        },
        de_DE: {
          dettaglioTrattativa: {
            trattativaNum: 'Verhandlung N.',
            del: 'die',
            nuovaTrattativa: 'Neue Verhandlung',
            validita: 'Gueltigkeit',
            numConf: 'Bestellung',
            datCons: 'Liefertermin',
            spedizione: 'Transportart',
            stabilimento: 'Werk',
            resa: 'Handelklausel',
            percTolleranza: 'Toleranz',
            notaUfficio: 'Noten Einkaufsbuero',
            subFornEProv: 'Ursprungsort',
            notaFornitore: 'Noten Lieferant',
            prodotto: 'Produkt',
            qta: 'Quantitaet (Tonn)',
            prezzo: 'Preis<br>(',
            prezzo2: '/Tonn)',
            prezzoRichiesto: 'Verlangte<br>Preis (',
            prezzoRichiesto2: '/Tonn)',
            prezzoMesePrec: 'Preis Der<br>Vormonat (',
            prezzoMesePrec2: '/Tonn)',
            differenza: 'Differenz',
            subFornLocProvTitle: 'Zuliefer und Ursprungsort',
            addProdottiTitle: 'Produkt Auswählen',
            aggiungi: 'Hinzufügen',
            salva: 'Speichern',
            divisa: 'Währung',
            aggiungiProdotto: 'Produkt Auswählen',
            subFornProv: 'Zuliefer und Ursprungsort',
            tipoMateriale: 'Materialart'
          }
        },
        en_GB: {
          dettaglioTrattativa: {
          }
        }
      }
    },
    data () {
      return {
        trattativa: {},
        testata: {
          validita: [],
          stabilimento: {},
          resa: '',
          datCons: [],
          spedizione: '',
          percTolleranza: '',
          notaUfficio: '',
          notaFornitore: '',
          localita: [],
          divisa: '',
          tipoMateriale: ''
        },
        codLang: sessionStorage.getItem('codLang'),
        stabilimenti: [],
        rese: [],
        tipiMateriale: [],
        tolleranze: [],
        spedizioni: [],
        elencoProdotti: [],
        loading: false,
        subFornLocProvVisible: false,
        addProdottiVisible: false,
        subFornitori: [],
        subFornSelected: [],
        locProv: [],
        locProvSavedSelected: [],
        locProvSaved: [],
        locProvSelected: [],
        prodotti: [],
        addProdottiSelected: [],
        divise: [],
        ifNuovaTrattativa: false,
        ifDisabled: false,
        loadingProdotti: false,
        filtroProdotti: '',
        ifAutomatica: false,     // Se la trattativa è generata automaticamente (numConf valorizzato) --> true,
        countryTrattativa: ''
      }
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    computed: {
      locProvComputed: function () {
        let arraySaved = []
        this.locProvSaved.forEach(item => {
          arraySaved.push(item.codLoca)
        })
        let array = []
        this.locProv.forEach(item => {
          if (arraySaved.indexOf(item.codLoca) < 0) {
            array.push(item)
          }
        })

        return array
      }
    },
    methods: {
      init: function () {
        this.$set(this, 'ifNuovaTrattativa', this.$store.state.nuovaTrattativa)
        let trattativa = this.$store.state.trattativa
        this.$set(this, 'countryTrattativa', this.$store.state.trattativaForm.country)
        if (trattativa !== undefined && Object.keys(trattativa).length !== 0 && trattativa.constructor === Object) {
          this.$set(this, 'trattativa', this.$store.state.trattativa)
          this.getRese()
          this.getTipiMat()
          this.getTolleranze()
          this.getSpedizioni()
          this.getSubfornitori()
          // this.getLocProv()
          // this.getProdotti()
          this.getDivise()
          this.getStabilimenti(this.loadTrattativa)
          if (this.$store.state.duplicaTrattativa === false) {
            if (trattativa.statoAvanzamento === 'D' || trattativa.statoAvanzamento === 'E'){
              this.$set(this, 'ifDisabled', true)
            }
          }
          if ((trattativa.statoAvanzamento !== 'D' && trattativa.statoAvanzamento !== 'E') && trattativa.numConf !== '') {
            this.$set(this, 'ifAutomatica', true)
          }
        } else {
          if (this.$store.state.nuovaTrattativa === false) {
            this.$router.push({ name: 'ElencoTrattative' })
          } else {
            this.getStabilimenti()
            this.getRese()
            this.getTipiMat()
            this.getTolleranze()
            this.getSpedizioni()
            this.getSubfornitori()
            this.getLocProv()
            // this.getProdotti()
            this.getDivise()
            this.$set(this.testata, 'divisa', 'EU')
          }
        }
      },
      resetDati: function () {
        this.$set(this, 'trattativa', {})
        let testata = {
          validita: [],
          stabilimento: {},
          resa: '',
          datCons: [],
          spedizione: '',
          percTolleranza: '',
          notaUfficio: '',
          notaFornitore: '',
          localita: [],
          divisa: '',
          tipoMateriale: ''
        }
        this.$set(this, 'testata', testata)
        this.$set(this, 'stabilimenti', [])
        this.$set(this, 'rese', [])
        this.$set(this, 'tipiMateriale', [])
        this.$set(this, 'tolleranze', [])
        this.$set(this, 'spedizioni', [])
        this.$set(this, 'elencoProdotti', [])
        this.$set(this, 'loading', false)
        this.$set(this, 'subFornLocProvVisible', false)
        this.$set(this, 'addProdottiVisible', false)
        this.$set(this, 'subFornitori', [])
        this.$set(this, 'subFornSelected', [])
        this.$set(this, 'locProv', [])
        this.$set(this, 'locProvSavedSelected', [])
        this.$set(this, 'locProvSaved', [])
        this.$set(this, 'locProvSelected', [])
        this.$set(this, 'prodotti', [])
        this.$set(this, 'addProdottiSelected', [])
        this.$set(this, 'divise', [])
        this.$set(this, 'ifNuovaTrattativa', false)
        this.$set(this, 'ifDisabled', false)
        this.$set(this, 'loadingProdotti', false)
        this.$set(this, 'filtroProdotti', '')
        this.$set(this, 'ifAutomatica', false)
      },
      formatQta: function (index) {
        let val = this.elencoProdotti[index].qtaOfferta
        val = val.replace(/\./g, '').toString()
        val = val.replace(/,/g, '').toString()
        val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

        this.$set(this.elencoProdotti[index], 'qtaOfferta', val)
        /*
        let val = this.elencoProdotti[index].qtaOfferta.replace(/\./g, '').toString()

        while (val.indexOf(',') !== val.lastIndexOf(',')) {
          let intero = val.substring(0, val.indexOf(','))
          let decimale = val.substring(parseInt(val.indexOf(',')) + 1, parseInt(val.lastIndexOf(',')))

          val = intero + ',' + decimale
        }
        if (val.indexOf(',') >= 0) {
          let intero = val.substring(0, val.indexOf(','))
          let decimale = val.substring(parseInt(val.indexOf(',')) + 1, val.length)
          if (decimale.length > 3) {
            val = intero + ',' + decimale.substring(0, 3)
          }
        }

        val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        this.$set(this.elencoProdotti[index], 'qtaOfferta', val)
        */
      },
      formatPrz: function (index, nomeCampo) {
        let val = this.elencoProdotti[index][nomeCampo].replace(/\./g, '')

        while (val.indexOf(',') !== val.lastIndexOf(',')) {
          let intero = val.substring(0, val.indexOf(','))
          let decimale = val.substring(parseInt(val.indexOf(',')) + 1, parseInt(val.lastIndexOf(',')))

          val = intero + ',' + decimale
        }
        if (val.indexOf(',') >= 0) {
          let intero = val.substring(0, val.indexOf(','))
          let decimale = val.substring(parseInt(val.indexOf(',')) + 1, val.length)
          if (decimale.length > 2) {
            val = intero + ',' + decimale.substring(0, 2)
          }
        }

        val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        this.$set(this.elencoProdotti[index], nomeCampo, val)
      },
      salva: function () {
        let form = this.$store.state.trattativaForm
        let trattativa = this.$store.state.trattativa
        let prodotti = []
        this.elencoProdotti.forEach(prod => {
          let obj = {
            codProd: prod.codProd,
            qtaOfferta: prod.qtaOfferta.replace(/\./g, ''),
            prezzoForn: prod.prezzoForn.replace(/\./g, ''),
            prezzoUff: prod.prezzoUff,
            divisa: prod.divisa
          }
          prodotti.push(obj)
        })
        this.$http.post(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/trattativa',
          {
            codSoc: this.testata.stabilimento.codSoc,
            numTrattativa: (trattativa.numTrattativa !== undefined) ? trattativa.numTrattativa : '',
            datTrattativa: (trattativa.datTrattativa !== undefined) ? trattativa.datTrattativa : '',
            datValDa: (this.testata.validita[0] !== undefined) ? this.testata.validita[0]: '',
            datValA: (this.testata.validita[1] !== undefined) ? this.testata.validita[1]: '',
            datConsDa: (this.testata.datCons[0] !== undefined) ? this.testata.datCons[0]: '',
            datConsA: (this.testata.datCons[1] !== undefined) ? this.testata.datCons[1]: '',
            eleSubforn: JSON.stringify(this.subFornSelected),
            eleLocalita: JSON.stringify(this.locProvSavedSelected.concat(this.locProvSelected)),
            codStab: this.testata.stabilimento.codStab,
            codSped: this.testata.spedizione,
            codResa: this.testata.resa,
            tolleranza: this.testata.percTolleranza,
            notaUff: this.testata.notaUfficio,
            notaForn: this.testata.notaFornitore,
            divisa: this.testata.divisa,
            codTipoMat: this.testata.tipoMateriale,
            prodotti: prodotti
          },
          {
            params: {
              codForn: form.fornitore.codForn,
              tipoForn: form.fornitore.tipForn
            }
          }
        )
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.$router.push({
                name: 'ElencoTrattative'
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      goToAddProdotti: function () {
        this.$set(this, 'addProdottiSelected', [])
        if (this.$refs.multipleTable !== undefined) {
          this.$refs.multipleTable.clearSelection()
        }
        this.$set(this, 'filtroProdotti', '')
        this.getProdotti()
        this.$set(this, 'addProdottiVisible', true)
      },
      addProdotti: function () {
        this.addProdottiSelected.forEach(item => {
          let obj = {
            codProd: item.codProd,
            desProd: item.desProd,
            codEurofer: item.codEurofer,
            codCECA: item.codCECA,
            qtaOfferta: '',
            prezzoForn: '',
            prezzoUff: '',
            prezzoMesePrec: '',
            differenza: '',
            numConf: '',
            ifElimina: true
          }
          this.elencoProdotti.push(obj)
        })
        this.$set(this, 'addProdottiVisible', false)
      },
      eliminaProdotto: function (index) {
        this.elencoProdotti.splice(index, 1)
      },
      changeSubFornProv: function () {
        this.$set(this, 'subFornLocProvVisible', false)
      },
      handleSelectionChange: function (val) {
        this.$set(this, 'addProdottiSelected', val)
      },
      loadTrattativa: function () {
        this.$set(this, 'loading', true)
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/trattativa', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn,
            codStab: this.trattativa.codStab,
            numTrattativa: this.trattativa.numTrattativa
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let attrib = response.body.attrib
              if (this.$store.state.duplicaTrattativa === true) {
                this.$set(this.testata, 'validita', [])
                this.$set(this.testata, 'datCons', [])
                this.$set(this.trattativa, 'numTrattativa', '')
              } else {
                this.$set(this.testata, 'validita', [attrib.datValDa, attrib.datValA])
                this.$set(this.testata, 'datCons', [attrib.datConsDa, attrib.datConsA])
              }
              this.$set(this.testata, 'resa', attrib.codResa)
              this.$set(this.testata, 'spedizione', attrib.codSped)
              this.$set(this.testata, 'percTolleranza', attrib.tolleranza)
              this.$set(this.testata, 'notaUfficio', attrib.notaUff)
              this.$set(this.testata, 'notaFornitore', attrib.notaForn)
              this.$set(this.testata, 'localita', attrib.eleLocalita)
              this.$set(this.testata, 'divisa', attrib.divisa)
              this.$set(this.testata, 'tipoMateriale', attrib.codTipoMat)
              if (attrib.codSoc !== '' && attrib.codStab !== '') {
                this.stabilimenti.forEach(item => {
                  if (item.codSoc === attrib.codSoc && item.codStab === attrib.codStab) {
                    this.$set(this.testata, 'stabilimento', item)
                  }
                })
              }

              let data = response.body.data
              data.forEach(prd => {
                prd.ifElimina = false
              })
              this.$set(this, 'elencoProdotti', data)
              this.elencoProdotti.forEach((prod, index) => {
                this.elencoProdotti[index].qtaOfferta = parseInt(this.elencoProdotti[index].qtaOfferta).toString()
                this.formatQta(index)
                this.formatPrz(index, 'prezzoForn')
                this.formatPrz(index, 'prezzoMesePrec')
                this.formatPrz(index, 'prezzoUff')
                this.formatPrz(index, 'differenza')
              })
              this.$set(this, 'subFornSelected', attrib.eleSubforn)
              let array = []
              this.testata.localita.forEach(item => {
                let obj = {
                  codLoca: item.codLoca,
                  desLoca: item.desLoca
                }
                this.locProvSavedSelected.push(item.codLoca)
                array.push(obj)
              })
              this.$set(this, 'locProvSaved', array)
              this.getLocProv()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.getLocProv()
            }
            this.$set(this, 'loading', false)
          })
      },
      getStabilimenti: function (callback) {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/stabilimenti', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              data.forEach(obj => {
                obj.key = obj.codSoc + '-' + obj.codStab
              })
              this.$set(this, 'stabilimenti', data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            if (callback !== undefined) {
              callback()
            }
          })
      },
      getRese: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/rese', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'rese', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getTipiMat: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/tipimat', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tipiMateriale', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getTolleranze: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/tolleranze', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tolleranze', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getSpedizioni: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/spediz', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'spedizioni', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getSubfornitori: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/subforn', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'subFornitori', response.body.data)
            } else {
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
            }
          })
      },
      changeSubFornSelected: function () {
        this.getLocProv()
      },
      getLocProv: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/locprov', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn,
            seFiltro: '',
            eleSubforn: JSON.stringify(this.subFornSelected)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              let arr = []
              data.forEach(obj => {
                //
              })
              this.$set(this, 'locProv', data)
              let arrayLocProv = []
              this.locProv.forEach(item => {
                arrayLocProv.push(item.codLoca)
              })
              let array = []
              this.locProvSelected.forEach(loc => {
                if (arrayLocProv.indexOf(loc) >= 0) {
                  array.push(loc)
                }
              })
              this.$set(this, 'locProvSelected', array)
            } else {
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
            }
          })
      },
      getProdotti: function () {
        this.$set(this, 'loadingProdotti', true)
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/prodotti', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn,
            filtro: this.filtroProdotti
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'prodotti', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loadingProdotti', false)
          })
      },
      getDivise: function () {
        let form = this.$store.state.trattativaForm
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + form.country + '/divise', {
          params: {
            codForn: form.fornitore.codForn,
            tipoForn: form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'divise', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";
  @import "../../../assets/less/el-date-picker.less";
  @import "../../../assets/less/el-input.less";
  @import "../../../assets/less/el-select.less";
  @import "../../../assets/less/el-table.less";
  @import "../../../assets/less/el-dialog.less";
  @import "../../../assets/less/el-checkbox.less";
  @import "../../../assets/less/el-button.less";

  .dialog-subforn-locprov {
    .contenitore {
      display: flex;
      justify-content: space-between;
      .box-sx {
        height: 300px;
        width: 48%;
        float: left;
        border: 1px solid #ccc;
        overflow: auto;
      }
      .box-dx {
        height: 300px;
        width: 48%;
        float: right;
        border: 1px solid #ccc;
        overflow: auto;
      }
    }
  }

  .dialog-prodotti {
    .filtro {
      text-align: center;
      .input-filtro {
        width: 270px;
        display: inline-block;
      }
      .ricerca {
        display: inline-block;
        margin-left: 10px;
      }
    }
    .contenitore {
      height: 380px;
      overflow: auto;
      margin-top: 20px;
      .el-table {
        .el-table__body {
          tbody {
            tr {
              td {
                padding: 2px !important;
              }
            }
          }
        }
      }
    }
  }

  .dettaglio-trattativa {
    .header-tab {
      height: 80px;
      text-align: center;
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva, @size: 22px, @family: 'os-semibolditalic');
      }
      .sotto-label {
        .set-font(@size: 15px, @family: 'os-lightitalic');
        height: 25px;
      }
    }
    .testata-trattativa {
      margin-top: 25px;
      .elemento {
        margin-bottom: 10px;
        .el-label {
          .set-font(@size: 14px; @color: @greenRiva);
          text-align: right;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .add {
      margin-top: 15px;
      margin-bottom: 10px;
      text-align: left;
      .el-button {
        padding: 13px 10px;
      }
    }
    .prodotti {
      margin-top: 25px;
      .el-table {
        .cell {
          .prodotto {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .el-input__inner {
            text-align: center;
          }
        }
      }
    }
    .bottoni {
      margin-top: 10px;
      text-align: right;
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneTrattativa/DettaglioTrattativa.vue